import React from "react";
import { useTheme } from "../../providers/theme-provider";
import useWindowSize from "../../hooks/use-window-size";
import { useTranslation } from "react-i18next";
import spacings from "../../theme/spacings";
import { assetImages } from "../../constants/assets";
import { fontSizes } from "../../theme/font-sizes";
import Accordion from "./accordian";

const DesignBrilliance = () => {
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 1024;

  const isLarge = width >= 768;

  const { t } = useTranslation();

  const paddingLeftRight = isMobile
    ? spacings.leftRightSpacingMobile
    : spacings.leftRightSpacing;

  const paddingTopBottom = isMobile
    ? spacings.topBottomSpacingMobile
    : spacings.topBottomSpacing;

  return (
    <div
      style={{
        backgroundColor: colors.heroBg,
        paddingLeft: paddingLeftRight,
        paddingRight: paddingLeftRight,
        paddingTop: paddingTopBottom,
        paddingBottom: paddingTopBottom,
      }}
      className="max-w-[1400px] mx-auto "
    >
      <div className="md:grid md:grid-cols-2 lg:gap-12 md:gap-6 place-content-between">
        <div className="relative">
          <img src={assetImages.brilliance} alt="" className="" />

          {!isLarge && (
            <div
              className="p-4 absolute top-[36%]"
              style={{
                backgroundColor: colors.background,
              }}
            >
              <h3
                className="font-semibold"
                style={{
                  fontSize: fontSizes.heading2,
                  color: colors.mainHeading,
                }}
              >
                {t("designHeading")}
              </h3>
            </div>
          )}
        </div>

        <div className="flex flex-col xl:gap-10 lg:gap-3 gap-2">
          {isLarge && (
            <h3
              className="font-semibold"
              style={{
                fontSize: fontSizes.heading2,
                color: colors.mainHeading,
              }}
            >
              {t("designHeading")}
            </h3>
          )}

          <p
            style={{
              fontSize: fontSizes.body,
              color: colors.mainText,
            }}
            className={isLarge ? "" : "mt-4"}
          >
            {t("designText")}
          </p>

          <div className="xl:mt-6">
            <Accordion />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignBrilliance;
